import React, { useState } from "react";
import data from "./data";
function App() {
  const [count, setCount] = useState(0);
  const [text, setText] = useState([]);

  function handleSubmit(e) {
    e.preventDefault();

    let amount = parseInt(count);

    if (count <= 0) {
      amount = 0;
    } else if (count > 8) {
      amount = 8;
    }

    setText(data.slice(0, amount));
  }

  function handleReset() {
    let inputReset = document.getElementById("amount");
    inputReset.value = "";
    setText([]);
    setCount(0);
  }

  return (
    <section className="section-center">
      <h3>tired of boring lorem ipsum?</h3>
      <form className="lorem-form" onSubmit={handleSubmit}>
        <label htmlFor="amount">paragraphs:</label>
        <input type="number" name="amount" id="amount" onChange={(e) => setCount(e.target.value)} />
        <button type="submit" className="btn">
          Generate
        </button>
        <button className="btn button-margin" onClick={handleReset}>
          Reset
        </button>
      </form>
      <article className="lorem-text">
        {text.map((item, index) => {
          return <p key={index}>{item}</p>;
        })}
      </article>
    </section>
  );
}

export default App;
